import ApiClient from "../ApiClient";
import NewUUID from "../../utils/randy/NewUUID";

/**
 * Fetches a single page of transactions (cursor-based). Returns Promise<{ items, next_cursor }>.
 * cursor empty = first page. Limit is controlled by backend (env/config).
 */
export const fetchTransactionsPage = async (csrfToken, templateId, cursor = '') => {
    let url = `/api/bills/template/${String(templateId)}/transactions`;
    if (cursor) url += `?cursor=${encodeURIComponent(cursor)}`;
    const response = await ApiClient.get(url, {
        headers: {
            accept: "text/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    const result = response.data.result ?? [];
    const nextCursor = response.data.next_cursor ?? '';
    return { items: result, next_cursor: nextCursor };
};

/**
 * Fetches first page of transactions for a template. Returns { items, next_cursor }.
 * queryKey: ['transactions', templateId, { cursor }]. cursor empty for first page. Limit from backend.
 */
export const listTemplateTransactions = (csrfToken) => {
    return async ({ queryKey }) => {
        const [_, templateId, pageOpts] = queryKey;
        const cursor = pageOpts?.cursor ?? '';
        let url = `/api/bills/template/${templateId.toString()}/transactions`;
        if (cursor) url += `?cursor=${encodeURIComponent(cursor)}`;
        const response = await ApiClient.get(url, {
            headers: {
                accept: "text/json",
                request_id: NewUUID(),
                "X-CSRF-Token": csrfToken
            },
        });
        const result = response.data.result ?? [];
        const nextCursor = response.data.next_cursor ?? '';
        return { items: result, next_cursor: nextCursor };
    };
};

export const addNewTransaction = (csrfToken) => {
    return async (formData) => {
        try {
            const response = await ApiClient.post(
                `/api/bills/template/${formData.templateId}/transactions`,
                {
                    amount: formData.amount,
                    statement_id: formData.statement_id,
                    user_sub: formData.user_sub,
                },
                {
                    headers: {
                        accept: 'application/json',
                        request_id: NewUUID(),
                        "X-CSRF-Token": csrfToken
                    },
                }
            );

            return response.data.result;
        } catch (error) {
            console.error('Error adding template transaction:', error);
            throw error; // Re-throw the error to propagate it to the mutation
        }
    };
};

export const verifyTransaction = (csrfToken) => {
    return async ({ statementId, transactionId, templateId, verified }) => {
        try {
            // Note: Using statementId in the path as specified by backend API
            // Endpoint: POST /api/bills/template/{statement_id}/transactions/{transaction_id}/verification
            const response = await ApiClient.post(
                `/api/bills/template/${statementId}/transactions/${transactionId}/verification`,
                {
                    template_id: Number(templateId), // Ensure template_id is sent as a number
                    verified: verified
                },
                {
                    headers: {
                        accept: 'application/json',
                        request_id: NewUUID(),
                        "X-CSRF-Token": csrfToken
                    },
                }
            );

            return response.data.result;
        } catch (error) {
            console.error('Error verifying transaction:', error);
            throw error;
        }
    };
};
